import type { FC } from 'react';

interface Props {
  className?: string;
}

const RecyclingIcon: FC<Props> = ({ className = 'w-5 h-5 mr-1' }) => {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M4 4l5 7m0 0l5-7m-5 7l6.464 6.464a1 1 0 001.415 0l2.828-2.828a1 1 0 000-1.415L12 4m0 0L9.172 6.828a1 1 0 01-1.414 0L4.93 4"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M17 17h3l-4 4-4-4h3v-3M7 7V4l-4 4 4 4V9h3"
      />
    </svg>
  );
};

export default RecyclingIcon;
